import styles from './DegradedIndicator.module.scss';
import Tooltip from '../../../../../common/_custom/Tooltip/Tooltip';
import { buildDegradedSummary, DEGRADED_GLYPH } from '../constants/reconciliationsCopy';
import type { ReconDegraded } from '../../../../../store/reconciliations/types';

interface DegradedIndicatorProps {
    degraded: ReconDegraded;
}

/** Shared ⚠ glyph + mandatory tooltip for every surface that must signal "computed on partial
 *  data" at a glance (D27a) — the sidebar chip and the 4 scope pills. One markup so the two
 *  surfaces can never drift (A-125, A-126a). `usePortal`: both mount inside scrolling/sticky
 *  sidebar and tab containers, so the tip would otherwise clip. */
function DegradedIndicator({ degraded }: Readonly<DegradedIndicatorProps>) {
    return (
        <Tooltip content={buildDegradedSummary(degraded)} direction="top" usePortal fitContent>
            <span className={styles.DegradedGlyph}>{DEGRADED_GLYPH}</span>
        </Tooltip>
    );
}

export default DegradedIndicator;
